import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../../utils/getTestLabels.js';
import { LoaderGifBase } from '../../base/LoaderGifBase/LoaderGifBase.js';

const { componentTestLabel } = getTestLabels('LoaderGif');
/**
 * @deprecated use LoaderSvg instead
 *
 * @param {boolean} fullPage - (optional) Set to `true` to overlay the entire page.
 */
const LoaderGif = forwardRef((props, ref) => (jsx(LoaderGifBase, { "data-zta": componentTestLabel, theme: "zooplus", ref: ref, ...props })));
LoaderGif.displayName = 'LoaderGif';

export { LoaderGif };
//# sourceMappingURL=LoaderGif.js.map
